<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center">
              <p class="mb-0 font-weight-bold">
                商品政策文案 (Storefront Policy)
              </p>
              <button
                class="btn btn-primary btn-sm ms-auto"
                @click="savePolicy"
                :disabled="saving"
              >
                {{ saving ? "儲存中..." : "儲存變更" }}
              </button>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <label for="product-policy" class="form-control-label"
                  >運送與退換貨政策</label
                >
                <textarea
                  id="product-policy"
                  class="form-control"
                  rows="15"
                  v-model="policyText"
                  placeholder="請輸入顯示於商品詳情頁的政策說明..."
                ></textarea>
                <small class="text-muted"
                  >此內容將顯示在每一件商品的詳情頁下方「運送與退換貨」區塊。</small
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";
import Swal from "sweetalert2";

export default {
  name: "ProductPolicy",
  data() {
    return {
      policyText: "",
      saving: false,
    };
  },
  methods: {
    async fetchPolicy() {
      try {
        const response = await request.get(
          "/api/shop/site-settings/product_policy_text"
        );
        if (response.data) {
          this.policyText = response.data.value || "";
        }
      } catch (error) {
        if (error.response && error.response.status === 404) {
          // Policy not set yet, ignoring
          return;
        }
        console.error("Failed to fetch policy", error);
      }
    },
    async savePolicy() {
      this.saving = true;
      try {
        await request.post("/api/admin/product-policy", {
          policy_content: this.policyText,
        });
        Swal.fire("成功", "商品政策已更新", "success");
      } catch (error) {
        console.error("Failed to save policy", error);
        Swal.fire("錯誤", "儲存失敗", "error");
      } finally {
        this.saving = false;
      }
    },
  },
  mounted() {
    this.fetchPolicy();
  },
};
</script>
